const NUMBER_CANDIDATE_REGEX = /(^|[^\w@])(\+?\d[\d\s().-]{2,}\d|\(?\d{2}\)?[\s.-]*\d{3,}[\d\s.-]*)(?=$|[^\w@])/g;

const collectProtectedRanges = (text) => {
  const protectedRanges = [];
  const regexes = [
    /https?:\/\/[^\s]+/gi,
    /www\.[^\s]+/gi,
    /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi,
    /\[([^\]]*)\]\(([^)]*)\)/g,
    /`[^`]*`/g,
    /\d{1,4}[/.]\d{1,2}[/.]\d{1,4}/g,
    /\d{1,2}:\d{2}(:\d{2})?/g,
    /(?:R\$\s*)?\d{1,3}(?:\.\d{3})*,\d{2}/gi,
  ];

  regexes.forEach((regex) => {
    let match;
    regex.lastIndex = 0;
    while ((match = regex.exec(text)) !== null) {
      protectedRanges.push({ start: match.index, end: match.index + match[0].length });
    }
  });

  return protectedRanges;
};

const overlapsProtectedRange = (ranges, start, end) => (
  ranges.some((range) => start < range.end && end > range.start)
);

export const normalizePhoneNumber = (raw) => {
  const digits = String(raw || "").replace(/\D/g, "");
  let normalized = digits;

  if (!normalized.startsWith("55") && (normalized.length === 10 || normalized.length === 11)) {
    normalized = `55${normalized}`;
  }

  if (!/^55\d{10,11}$/.test(normalized)) return null;

  const ddd = Number(normalized.slice(2, 4));
  const local = normalized.slice(4);

  if (ddd < 11 || ddd > 99) return null;
  if (!/^[2-9]\d{7,8}$/.test(local)) return null;

  return normalized;
};

export const parsePhoneNumbers = (text) => {
  if (!text || typeof text !== "string") {
    return [{ type: "text", value: text || "" }];
  }

  const protectedRanges = collectProtectedRanges(text);
  const result = [];
  let lastIndex = 0;
  let match;

  NUMBER_CANDIDATE_REGEX.lastIndex = 0;
  while ((match = NUMBER_CANDIDATE_REGEX.exec(text)) !== null) {
    const prefix = match[1] || "";
    const raw = match[2];
    const start = match.index + prefix.length;
    const end = start + raw.length;

    if (overlapsProtectedRange(protectedRanges, start, end)) continue;
    if (raw.includes("\n") || raw.includes("\r")) continue;
    if ((raw.match(/\d/g) || []).length < 3) continue;

    const normalized = normalizePhoneNumber(raw);

    if (start > lastIndex) {
      result.push({ type: "text", value: text.slice(lastIndex, start) });
    }

    result.push({
      type: normalized ? "phone" : "number",
      value: raw,
      normalized: normalized || null,
      copyValue: normalized || raw.trim()
    });
    lastIndex = end;
  }

  if (lastIndex < text.length) {
    result.push({ type: "text", value: text.slice(lastIndex) });
  }

  return result.length ? result : [{ type: "text", value: text }];
};
